import type { ReactNode } from "react";
import { Outlet } from "react-router";
import { Container, Grid } from "@mui/material";
import { useDocumentTitle } from "hooks";
import { withPageErrorBoundary } from "utils/errorHandling";
import { usePersistentValue } from "@sdeapps/react-core";
import { localStorageKeys } from "config/app-config";
import { NavigationMenu } from "./Header/NavigationMenu";

function Root(): ReactNode {
  useDocumentTitle();
  const [isNavMenuOpen, setIsNavMenuOpen] = usePersistentValue<boolean>(
    localStorageKeys.isNavigationMenuOpen,
    true
  );

  return (
    <Grid container size={1}>
      <Grid size="auto">
        <NavigationMenu isOpen={isNavMenuOpen} onOpen={setIsNavMenuOpen} />
      </Grid>
      <Grid size="grow" component="main">
        <Container maxWidth={false}>
          <Outlet />
        </Container>
      </Grid>
    </Grid>
  );
}

export const RootWithErrorBoundary = withPageErrorBoundary(Root);
